import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import CountUp from 'react-countup'

import Font from '@cred/react-font'
import modalActions from '@cred/react-modal/actions'

import Modal from 'components/modal'
import Link from 'components/link'

import { CALCULATOR_DISCLOSURE_MODAL_NAME } from '../../constants'
import { savingsCalculatorDisclosureModalContext, savingsCalculatorContext } from '../../analytics'
import styles from './styles.module.scss'

const generateOpenDisclosureModal = (openModal) => () => {
  openModal(CALCULATOR_DISCLOSURE_MODAL_NAME)
}

const SavingsContent = ({ savings, openModal }) => (
  <>
    <Font color="lighter" weight="semiBold" type="bodySmall" className="align-center mb-8">
      You could be saving
    </Font>
    <Font type="medium" color="secondary" weight="bold" className={styles.savingsAmountText}>
      <Font
        type="heading"
        color="secondary"
        weight="bold"
        element="span"
        className={styles.dollarSymbol}
      >
        $
      </Font>
      <CountUp start={0} end={savings} duration={0.5} useGrouping separator="," />
    </Font>
    <Link
      color="primary"
      underline="dashed"
      weight="semiBold"
      type="bodySmall"
      analyticsContexts={savingsCalculatorContext}
      onClick={generateOpenDisclosureModal(openModal)}
    >
      How do we calculate this?
    </Link>
    <Modal
      name={CALCULATOR_DISCLOSURE_MODAL_NAME}
      title="How do we calculate this?"
      dismiss
      analyticsContexts={savingsCalculatorDisclosureModalContext}
    >
      <Font type="disclaimer" color="lighter" className="mt-8 mb-8">
        The estimated savings calculation is derived by taking the estimated lifetime cost of paying
        off credit card debt minus the total estimated lifetime cost of a personal loan from one of
        Credible’s partners, based on the assumptions outlined below.
      </Font>
      <Font type="disclaimer" color="lighter" className="mt-8 mb-8">
        Credible’s savings methodology assumes the following about the current credit card debt: 1)
        an APR of 18.35% (which is an average credit card APR for persons with a credit score of
        739+); and 2) the credit card debt is paid off in 48 equal monthly payments, with no late
        payments and no additional expenses incurred on the credit card during this time period; and
        3) the outstanding balance on the credit card is equal to the loan amount input into the
        calculator. The calculation also assumes the following about the personal loan selected
        through Credible: 1) an APR of 10.45% (the average APR shown on Credible for borrowers with
        a credit score of 739+); and 2) the loan is paid on-time for the duration of a 48 month term
        and no pre-payments are made.
      </Font>
      <Font type="disclaimer" color="lighter" className="mt-8 mb-8">
        This estimate does not account for how payments are allocated or how interest is calculated.
        Actual savings may vary based on interest rates, balances, remaining repayment term, credit
        score and other factors. The estimated savings amount is not representative of your current
        situation or qualifications and is not a commitment to lend. There are no guarantees or
        representations that you will qualify for a loan with a lender on the Credible marketplace.
      </Font>
    </Modal>
  </>
)

SavingsContent.propTypes = {
  savings: PropTypes.number,
  openModal: PropTypes.func,
}

const mapDispatchToProps = (dispatch) => ({
  openModal: bindActionCreators(modalActions, dispatch).openModal,
})

export { SavingsContent }

export default connect(null, mapDispatchToProps)(SavingsContent)
